// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39lg8","col":"styles_col__GrpNu"};